import { render } from "./ProscanUploadDialog.vue?vue&type=template&id=7ec87dd1&scoped=true"
import script from "./ProscanUploadDialog.vue?vue&type=script&lang=js"
export * from "./ProscanUploadDialog.vue?vue&type=script&lang=js"

import "./ProscanUploadDialog.vue?vue&type=style&index=0&id=7ec87dd1&lang=css"
import "./ProscanUploadDialog.vue?vue&type=style&index=1&id=7ec87dd1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec87dd1"]])

export default __exports__